"use strict";

/**
 * @file Retrieve Hive API results that are stored in Firestore.
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMaxScore = exports.fetchData = exports.SCORE_UPPER_LIMIT = exports.SCORE_LOWER_LIMIT = exports.MODERATED_CLASSES = void 0;
var resource_store_1 = require("./resource_store");
/**
 * We are moderating these classes of a video that is analyzed by Hive.
 */
var MODERATED_CLASSES = ['general_nsfw', 'general_suggestive'];
exports.MODERATED_CLASSES = MODERATED_CLASSES;
var SCORE_LOWER_LIMIT = 0;
exports.SCORE_LOWER_LIMIT = SCORE_LOWER_LIMIT;
var SCORE_UPPER_LIMIT = 1;
exports.SCORE_UPPER_LIMIT = SCORE_UPPER_LIMIT;
var COLLECTION_NAME = 'link:hive:v1';
var DEFAULT_PAGE_LIMIT = 10;
var buildQueries = function (filter) {
  return [{
    field: "maxScore." + filter.className,
    operand: '>=',
    value: filter.lowerScore
  }, {
    field: "maxScore." + filter.className,
    operand: '<=',
    value: filter.upperScore
  }];
};
var fetchData = function (_a) {
  var filter = _a.filter,
    limit = _a.limit,
    startAfter = _a.startAfter;
  return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, (0, resource_store_1.findBy)({
            collectionName: COLLECTION_NAME,
            queries: filter ? buildQueries(filter) : [],
            orderBy: filter ? ["maxScore." + filter.className, 'desc'] : undefined,
            startAfter: startAfter,
            pageLimit: limit || DEFAULT_PAGE_LIMIT
          })];
        case 1:
          data = _b.sent();
          return [2 /*return*/, data];
      }
    });
  });
};
exports.fetchData = fetchData;
var calculateMaxScore = function (frames, className) {
  var currentMax = Number.MIN_SAFE_INTEGER;
  for (var _i = 0, frames_1 = frames; _i < frames_1.length; _i++) {
    var frame = frames_1[_i];
    var cls = frame.classes.find(function (c) {
      return c.class === className;
    });
    if (cls && cls.score > currentMax) {
      currentMax = cls.score;
    }
  }
  return currentMax;
};
exports.calculateMaxScore = calculateMaxScore;